module.exports = __webpack_public_path__ + "img/album10_02.970a5d94.jpg";